import React, { useMemo } from "react";
import { TokenBadge } from "~/components/TokenBadge/TokenBadge";
import { TokenIconSize } from "~/components/TokenIcon";
import { TradeOrder } from "~/types";
import TagDirection from "../components/TagDirection";
import TagType from "../components/TagType";
import { ORDER_DIRECTION } from "~/pages/constants";
import { useNavigate } from "react-router";

type TradeOrderTokenBadgeProps = {
    order: TradeOrder;
};

const TradeOrderTokenBadge: React.FC<TradeOrderTokenBadgeProps> = ({
    order,
}) => {
    const badgeTokens = useMemo(() => {
        const result: TradeOrder["from_token"][] = [];
        if (order.direction === ORDER_DIRECTION.buy) {
            result.push(order.to_token);
        } else if (order.direction === ORDER_DIRECTION.sell) {
            result.push(order.from_token);
        } else {
            result.push(order.from_token);
            result.push(order.to_token);
        }
        return result.filter(Boolean);
    }, [order]);

    const badgeTokenNames = useMemo(() => {
        return badgeTokens.map((token) => token.symbol.toUpperCase()).join("/");
    }, [badgeTokens]);

    const navigate = useNavigate();

    const fromToken = useMemo(() => {
        if (order.direction === ORDER_DIRECTION.buy) {
            return order.to_token;
        } else if (order.direction === ORDER_DIRECTION.sell) {
            return order.from_token;
        } else {
            return order.from_token;
        }
    }, [order]);

    const handleClick = (
        event: React.MouseEvent<HTMLSpanElement, MouseEvent>
    ) => {
        event.stopPropagation();
        const chain_id = String(fromToken.chain_id);
        const contract = String(fromToken.contract);
        navigate(`/k-detail?chain_id=${chain_id}&contract=${contract}`);
    };

    return (
        <div className="flex items-center">
            <span className=" cursor-pointer" onClick={handleClick}>
                {badgeTokens.map((token, index) => {
                    return (
                        <TokenBadge
                            key={index}
                            size={TokenIconSize.mini32}
                            tailIconSize={TokenIconSize.mini16}
                            tailIconClass="!border-[1.5px]"
                            icon={token.logo}
                            chainIcon={token.chain_logo}
                            symbol={token.symbol}
                            chainName={token.chain_name}
                            tokenIconBorder={true}
                        />
                    );
                })}
            </span>
            <div className="ml-[6px]">
                <div className="text-text_1 text-body1 font-Semibold">
                    {badgeTokenNames}
                </div>
                <div className="flex">
                    <TagType type={order.order_type} />
                    <TagDirection type={order.direction} />
                </div>
            </div>
        </div>
    );
};

export default React.memo(TradeOrderTokenBadge);
